
const TOMCAT_DOMAIN = process.env.REACT_APP_TOMCAT_DOMAIN || ""
const TOMCAT_DOMAIN_HERTZ_GOLD = `//${TOMCAT_DOMAIN}/sharedservices/hertzgold.jsp`


export const resolveOrRejectMemberData = (res,resolve,reject)=>{

  console.log(res)
  
  // if we succeded
  if(res.success && res.premier==true){
  
    // Send back the name
    resolve(res.member.firstName+" "+res.member.lastName)
  }else{
    
    // Send back an error
    reject("Either the AAA Membership Number was entered incorrectly or is not a AAA Premier account. Please try again or call your AAA office to upgrade to Premier.")
  }
}

export const sendHertzGoldData = function(recaptchaToken,hertzGoldPlusRewards,membershipNumber,postalCode){

    return new Promise((resolve,reject)=>{

        
    try{

        const config = {
          headers:{ "Authorization":recaptchaToken },
          method:"POST"
        }
  
        fetch(`${TOMCAT_DOMAIN_HERTZ_GOLD}?membershipNumber=${membershipNumber}&postalCode=${postalCode}&hertzGoldPlusRewards=${hertzGoldPlusRewards}`,config)
        .then(res=>res.json())
        .then(res=>resolveOrRejectMemberData(res,resolve,reject))
        .catch(e=>{
          console.log(e)
  
          // Send back an error
          reject("Either the AAA Membership Number was entered incorrectly or is not a AAA Premier account. Please try again or call your AAA office to upgrade to Premier.")
        })
  
      }catch(e){
        
        
        // Send back an error
        reject("Either the AAA Membership Number was entered incorrectly or is not a AAA Premier account. Please try again or call your AAA office to upgrade to Premier.")
        }
    
    })
}